/**
 * @fileoverview DELETE handler for the "/engagement/canvas/active_draft/:workflow_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasActiveDraftWorkflowIdCacheKeys } from "./constants";
import type {
  DeleteEngagementCanvasActiveDraftWorkflowIdProps,
  EngagementCanvasActiveDraftWorkflowIdResult,
} from "./types";

export const deleteEngagementCanvasActiveDraftWorkflowId = reactQueryMutationAdapter(
  engagementCanvasActiveDraftWorkflowIdCacheKeys,
  ({
    workflowId,
    lastEditChangelogId,
  }: DeleteEngagementCanvasActiveDraftWorkflowIdProps): Promise<EngagementCanvasActiveDraftWorkflowIdResult> => {
    // manipulate props here as needed lastEditChangelogId

    return fetch(
      `/engagement/canvas/active_draft/${workflowId}`,
      "DELETE",
      {
        last_edit_changelog_id: lastEditChangelogId,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
